import React from "react";
import { Helmet } from "react-helmet";
import { useIntl } from "react-intl";

const AppHeader = props => {
  const { locale } = useIntl();

  return (
    <>
      <Helmet>
        <html lang={locale} />
      </Helmet>
    </>
  );
};

export default AppHeader;
